<!-- 货主 -->
<template>
    <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}">
                <template slot="tabs" slot-scope="scope">
                    <div v-if="scope.index==0">
                        <el-form size="mini" label-width="120px" class="baseForm">
                            <el-row>
                                <el-form-item label="货主名称">
                                    <el-input v-model.trim="sendDataInfo.coName" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="货主编号">
                                    <el-input v-model.trim="sendDataInfo.coCode" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="助记码">
                                    <el-input v-model="sendDataInfo.coMne" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="货主费率">
                                    <el-input v-model.trim="sendDataInfo.manageFee" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                 <el-form-item label="高开费率">
                                    <el-input v-model.trim="sendDataInfo.goodManageFee" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="价格范围上限">
                                    <el-input v-model.number="sendDataInfo.coMax" type="number" :maxlength="$store.state.inputLength">
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="价格范围下限">
                                    <el-input v-model.number="sendDataInfo.coMin" type="number" :maxlength="$store.state.inputLength">
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="科目">
                                    <el-input v-model.trim="sendDataInfo.coSuject" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="手机号">
                                    <el-input v-model.trim="sendDataInfo.coPhone" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="身份证号">
                                    <el-input v-model.trim="sendDataInfo.coIdcard" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="范围计算类型">
                                    <el-select v-model="sendDataInfo.rangeType" placeholder="请选择计算类型">
                                        <el-option label="按成本价" :value=0></el-option>
                                        <el-option label="按建议售价" :value=1></el-option>
                                        <el-option label="按批次最低售价" :value=2></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="招商经理">
                                    <el-input v-model.trim="sendDataInfo.leasManager" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="是否全国归口企业">
                                    <el-radio-group v-model="sendDataInfo.isUnder" size="mini">
                                        <el-radio-button :label="0">否</el-radio-button>
                                        <el-radio-button :label="1">是</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="归口企业名称">
                                    <el-input v-model.trim="sendDataInfo.underName" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="是否月结">
                                    <el-radio-group v-model="sendDataInfo.isYj" size="mini">
                                        <el-radio-button :label="0">否</el-radio-button>
                                        <el-radio-button :label="1">是</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="备注">
                                    <el-input type="textarea" v-model.trim="sendDataInfo.remark" :maxlength="$store.state.inputLength">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="组合授信拦截">
                                    <el-radio-group v-model="sendDataInfo.comIntercept" size="mini">
                                        <el-radio-button :label="0">否</el-radio-button>
                                        <el-radio-button :label="1">是</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </el-row>
                        </el-form>
                    </div>
                </template>
            </v-tabs>
        </el-card>

        <div class="foot">
            <el-button type="primary" @click="initActionBox">取消</el-button>
            <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
            <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "cargoOwnerAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                coName: "", // 货主名称
                coCode: "",
                coId: "", // 货主ID
                coMax: "",
                coMin: "",
                coMne: "",
                coSuject: "", //	科目
                creditAccount: '',
                creditDead: '',
                coPhone: '',//手机号
                coIdcard: '',//身份证号
                remark: '',
                manageFee: '',
                goodManageFee:"",//高开费率
                rangeType: '',//范围计算类型
                leasManager: "",
                isUnder: 0,
                isYj: 0,
                underName: '',
                comIntercept: 0,
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.coName"() {
            //获取助记码
            this.sendDataInfo.coMne = this.$common.createPinyinCode(
                this.sendDataInfo.coName,
                this.sendDataInfo.coMne
            );
        },
    },
    //方法集合
    methods: {
        initActionBox() {
            this.$emit("drawerCancel");
            this.init();
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'isUnder'||key == 'isYj') {
                    this.sendDataInfo[key] = 0
                } else if (key == 'comIntercept') {
                    this.sendDataInfo[key] = 1
                } else{
                    this.sendDataInfo[key] = "";
                }
            }
        },

        openBox() {
            this.init();
            if (this.actionData.cate == 0) {
                this.dataActionBox.boxTitle = "新增货主信息";
            } else {
                this.dataActionBox.boxTitle = "编辑货主信息";
                var dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.showTabs = this.dataActionBox.boxTitle
            this.tabForm = [
                {
                    jciName: this.dataActionBox.boxTitle,
                    jurconfigform: [],
                }
            ]
            this.dataActionBox.actionType = this.actionData.cate;
        },
        async sendDataAction() {
            if (this.sendDataInfo.coName == "") {
                this.$message({
                    message: "请填写货主名称",
                    type: "error",
                });
                return false;
            }

            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addCarOwner(this.sendDataInfo);
            } else {
                var responseData = await this.$http.editCarOwner(this.sendDataInfo);
            }
            if (responseData.status == 200) {
                this.$emit("drawerCancel", true);
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.openBox()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>